function registerDirectives (Vue) {
  Vue.directive('overflow-title', {
    bind (el, binding) {
      el.dataset.titleText = binding.value;

      el.mouseHandler = () => {
        if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) {
          el.title = el.dataset.titleText;
        } else {
          el.removeAttribute('title');
        }
      };

      el.addEventListener('mouseover', el.mouseHandler);
    },
    update (el, binding) {
      el.dataset.titleText = binding.value;
    },
    unbind (el) {
      el.removeEventListener('mouseover', el.mouseHandler);
    }
  });

  Vue.directive('outside-click', {
    bind (el, binding) {
      el.clickHandler = (e) => {
        if (el.contains(e.target)) {
          return;
        }
        binding.value(e);
      };
      document.body.addEventListener('click', el.clickHandler);
    },
    unbind (el) {
      document.body.removeEventListener('click', el.clickHandler);
    }
  });

  function trimEmptyTextNodes (el) {
    for (let node of el.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.data.trim() === '') {
        node.remove();
      }
    }
  }

  Vue.directive('trim-whitespace', {
    inserted: trimEmptyTextNodes,
    componentUpdated: trimEmptyTextNodes
  });
}

export default registerDirectives;
